export default __webpack_public_path__ + "static/media/undraw_plan.481461ea.png";